import React, {useRef, useState, useEffect} from "react";
import {Link, useHistory} from "react-router-dom";
import qs from "qs";
import QRCode from "qrcode.react";
import moment from "jalali-moment";
import Setting from "../assets/images/setting.svg";
import Skeleton from "react-loading-skeleton";
import {ToastContainer, toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import redLogoCovidStatus from "../assets/images/covidStatusLogo/red-logo-covid-status.svg";
import greyLogoCovidStatus from "../assets/images/covidStatusLogo/grey-logo-covid-status.svg";
import greenLogoCovidStatus from "../assets/images/covidStatusLogo/green-logo-covid-status.svg";
import CONSTANTS from "../constants/constant.enum";
import userService from "../services/profile.service";

import HeadingSecondary from "../components/ HeadingSecondary";
import RefreshLogo2 from "../components/svg/RefreshLogo2";
import Eye from "../components/svg/Eye";
import Info from "../components/svg/Info";
import Danger from "../components/svg/Danger";
import EyeClose from "../components/svg/EyeClose";
import CloseIconX2 from "../components/svg/CloseIconX2";
import Vaccine from "../components/svg/margrave/Vaccine";
import ProfileNotification from "../components/ProfileNotification";

import ConfirmLogo from "../components/svg/ConfirmLogo";
import Spinner from "../components/Spinner";
import ScanHealthUserInfoBottomSheet from "../components/ScanHealthUserInfoBottomSheet";
import {getToken} from "../helper/helper";
import localStorageKeys from "../constants/localStorageKeys.enum";
import vaccineService from "../services/vaccination.service";

const Profile: React.FC<any> = (props: any) => {

  const [vaccinationCardInfo, setVaccinationCardInfo] = useState([]);
  const userHealthQrCodeParam = CONSTANTS.userHealthQrCodeParam;
  const [isHideNationalId, setIsHideNationalId] = useState(true);
  const [isHideBirthDate, setIsHideBirthDate] = useState(true);
  const [isScale, setIsScale] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [vaccinationLoading, setVaccinationLoading] = useState(false);
  const [
    scanHealthUserInfoByQrCodeLoading,
    setScanHealthUserInfoByQrCodeLoading,
  ] = useState(false);
  const [basicUserInfo, setBasicUserInfo] = useState({
    nationalId: "",
    birthDate: "",
  });

  const [healthUserInfo, setHealthUserInfo] = useState({
    qrCode: "",
    qrId: "",
    receiptDate: "",
    covidStatus: "",
    numberOfDozes: "",
    vaccineHistory: [],
  }) as any;


  const [errorsHealthUserInfo, setErrorsHealthUserInfo] = useState([]) as any;

  const [scanHealthUserInfo, setScanHealthUserInfo] = useState({
    firstName: "",
    lastName: "",
    nationalId: "",
    birthDate: "",
    covidStatus: "",
    receiptDate: "",
    numberOfDozes: "",
    vaccineHistory: [],
  }) as any;

  let [online, isOnline] = useState(navigator.onLine);

  const setOnline = () => {
    isOnline(true);
  };
  const setOffline = () => {
    isOnline(false);
  };

  useEffect(() => {
    window.addEventListener('offline', setOffline);
    window.addEventListener('online', setOnline);

    return () => {
      window.removeEventListener('offline', setOffline);
      window.removeEventListener('online', setOnline);
    }
  }, []);

  const status: any = {
    POSITIVE: {
      text: "مثبت",
      class: "u-red",
      logo: redLogoCovidStatus,
      flagStatus: "u-status-guild-red",
    },
    NEGATIVE: {
      text: "منفی",
      class: "u-green",
      logo: greenLogoCovidStatus,
      flagStatus: "u-status-guild-green",
    },
    UNKNOWN: {
      text: "ثبت نشده",
      class: "u-grey",
      logo: greyLogoCovidStatus,
      flagStatus: "u-status-guild-grey",
    },
  };

  const nationalIdTag = useRef<HTMLInputElement>(null);
  const birthDateTag = useRef<HTMLInputElement>(null);
  const history = useHistory();

  const isMounted = React.useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    const queryStringParsed = qs.parse(props.location.search.slice(1));
    // console.log(queryStringParsed);
    if (
      queryStringParsed[userHealthQrCodeParam] &&
      healthUserInfo.qrId !== ""
    ) {
      const scanHealthUserInfoByQrCode = async () => {
        setScanHealthUserInfoByQrCodeLoading(true);
        try {
          const {data} = await userService.scanHealthUserInfoByQrCode(
            queryStringParsed[userHealthQrCodeParam]
          );
          if (isMounted.current) {
            // console.log('http://192.168.43.16:3000/' + "?userHealthQrCode=" + data.qrCode);

            // local test "http://192.168.43.16:3000/profile" + "?" + userHealthQrCodeParam + "=" + data.qrCode,

            // stage test  window.location.href + "?" + userHealthQrCodeParam + "=" + data.qrCode,
            // let birthDate = data.birthDate;
            setScanHealthUserInfo({
              firstName: data.firstName,
              lastName: data.lastName,
              nationalId: data.nationalId,
              // birthDate:
              //   birthDate.slice(0, 4) +
              //   "/" +
              //   birthDate.slice(4, 6) +
              //   "/" +
              //   birthDate.slice(6),
              covidStatus: data.status ? data.status : "UNKNOWN",
              receiptDate: data.receiptDate,
              vaccineHistory:
                data.vaccineHistory === null ? [] : data.vaccineHistory,
              // numberOfDozes: data.numberOfDozes
              //   ? parseInt(data.numberOfDozes)
              //   : 0,
            });
          }
        } catch (error: any) {
          // alert(error);
          if (error.response) {
            notify(error.response.data?.message || "خطا در اتصال به سرور");
          } else if (error.request) {
            console.log("The request was made but no response was received");
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
        } finally {
          setScanHealthUserInfoByQrCodeLoading(false);
        }
      };

      scanHealthUserInfoByQrCode();
      setShowUserHealthBottomSheet(true);
    } else {
      console.log("");
    }
    // alert(queryStringParsed);
    // eslint-disable-next-line
  }, [healthUserInfo.qrId]);

  const getBasicUserInfo = async () => {
    try {
      const {data} = await userService.getUserInfo();

      let birthDate = data.birthDate;

      if (isMounted.current) {
        if (!getToken().firstName || !getToken().nationalId) {
          localStorage.setItem(
            localStorageKeys.tokenInfo,
            JSON.stringify({
              ...getToken(),
              firstName: data.firstName,
              lastName: data.lastName,
              gender: data.gender,
              nationalId: data.username,
              birthDate: data.birthDate,
            })
          );
        }
        if (data.email) {
          localStorage.setItem("email", data.email);
        }
        setBasicUserInfo({
          nationalId: data.username,
          birthDate:
            birthDate.slice(0, 4) +
            "/" +
            birthDate.slice(4, 6) +
            "/" +
            birthDate.slice(6),
        });
      }
    } catch (error: any) {
      if (error.response) {
        if (error.response.status >= 500) {
          notify("خطا در اتصال به سرور");
        }
      } else if (error.request) {
        console.log("The request was made but no response was received");
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const getHealthUserInfo = async () => {
    try {
      const {data} = await userService.getHealthInfo();

      if (isMounted.current) {
        // console.log('http://192.168.43.16:3000/' + "?userHealthQrCode=" + data.qrCode);

        // local test "https://192.168.1.51:3000/profile" + "?" + userHealthQrCodeParam + "=" + data.qrCode,

        // stage test  window.location.href + "?" + userHealthQrCodeParam + "=" + data.qrCode,
        // console.log(window.location.href);
        // if (data.receiptDate === null) {
        //   notify('اطلاعات آزمایش و واکسیناسیون شما در سامانه وزارت بهداشت ثبت نگردیده است.');
        // } else {
        //   notify('اطلاعات واکسیناسیون شما در سامانه وزارت بهداشت ثبت نگردیده است.');
        // }

        setHealthUserInfo({
          qrCode:
            window.location.href +
            "?" +
            userHealthQrCodeParam +
            "=" +
            data.qrCode,
          receiptDate: data.receiptDate,
          qrId: data.qrCode,
          covidStatus: data.status ? data.status : "UNKNOWN",
          vaccineHistory:
            data.vaccineHistory === null ? [] : data.vaccineHistory,
          numberOfDozes: data.numberOfDozes
            ? parseInt(data.numberOfDozes)
            : 0,
        });
        scanDiv.current!.className = "qr-code__image--fifty-shade-of-grey";
      }
    } catch (error: any) {
      if (error.response) {
        if (error.response.status >= 500) {
          notify("خطا در اتصال به سرور");
          setErrorsHealthUserInfo([
            {field: "", message: "خطا در دریافت اطلاعات"},
          ]);
        }
      } else if (error.request) {
        console.log("The request was made but no response was received");
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
    } finally {
      setLoading2(false);
    }
  };

  const getVaccinationInfo = async () => {
    try {

      const {data} = await vaccineService.getInternalVaccinationCard();
      // setIssueDate(data.issueDate);
      // setQrCode(data.qrCode);
      const vaccinationCard = data.vaccinationInfos;
      // const temp: any = [{}, {}, {}];
      // vaccinationCard.forEach((item: any, index: any) => {
      //   return temp.fill(item, index, ++index);
      // });
      setVaccinationCardInfo(vaccinationCard);
    } catch (error: any) {

      if (error.response) {
        notify(error.response.data?.message || "خطا در اتصال به سرور");
        // setErrors([{ field: "", message: "خطا در دریافت اطلاعات" }]);
      } else if (error.request) {
        console.log("The request was made but no response was received");
      } else {
        // Something happened in setting up the request that triggered an Error
        // console.log("Error", error.message);
        // setErrors([{ field: "", message: error.message }]);
      }
    } finally {
      setVaccinationLoading(false);
    }
  }

  useEffect(() => {

    setVaccinationLoading(true);
    setLoading(true);
    setLoading2(true);

    let delayReq = setTimeout(() => {
      getBasicUserInfo();
      getHealthUserInfo();
      getVaccinationInfo();
    }, 1000);

    return () => {
      clearTimeout(delayReq);
    };
    // eslint-disable-next-line
  }, [history]);

  const refreshQrCode = () => {
    scanDiv.current!.className = "";
    setTimeout(() => {
      scanDiv.current!.className = "qr-code__image--fifty-shade-of-grey";
    }, 0);
  };

  const scanDiv = useRef<HTMLDivElement>(null);
  const scaleDiv = useRef<HTMLDivElement>(null);

  const scaleQrCodeProfile = () => {
    if (isScale) {
      scaleDiv.current!.className = "qr-code__image-id-holder";
      setIsScale(false);
    } else {
      scaleDiv.current!.className =
        "qr-code__image-id-holder qr-code__image-id-holder--scale";
      setIsScale(true);
    }
  };

  const [showUserHealthBottomSheet, setShowUserHealthBottomSheet] =
    useState(false);
  const onDismiss = () => {
    history.replace("/profile");
    setShowUserHealthBottomSheet(false);
  };

  const notify = (text: string) => {
    toast(<ProfileNotification text={text}/>, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      closeButton: false,
      progress: undefined,
    });
  };

  return (
    <>
      <ToastContainer rtl/>
      <div className="profile">
        <div className="profile__setting">
          <Link to="/setting">
            <img src={Setting} alt="" className="profile__setting__img"/>
          </Link>
        </div>

        <ScanHealthUserInfoBottomSheet
          showUserHealthBottomSheet={showUserHealthBottomSheet}
          onDismiss={onDismiss}
          scanHealthUserInfo={scanHealthUserInfo}
          loading={scanHealthUserInfoByQrCodeLoading}
        />

        <div className="u-margin-top-small-3 u-margin-bottom-small-2">
          <HeadingSecondary text="اطلاعات حساب شهروندی"/>
        </div>

        {loading2 ? (
          <div className="u-margin-bottom-big-8">
            <Spinner/>
          </div>
        ) : (
          <div className="qr-code">
            <div
              className="qr-code__image-id-holder"
              ref={scaleDiv}
              onClick={scaleQrCodeProfile}
            >
              {isScale && (
                <div className="qr-code__image-id-holder__closeicon">
                  <CloseIconX2 color="#B2B2B2"/>
                </div>
              )}

              <div className="qr-code__image u-margin-bottom-small-2">

                <div className={`qr-code__image--line--1 ${online ? 'on' : 'off'}`}/>
                <div className={`qr-code__image--line--2 ${online ? 'on' : 'off'}`}/>
                <div className={`qr-code__image--line--3 ${online ? 'on' : 'off'}`}/>
                <div className={`qr-code__image--line--4 ${online ? 'on' : 'off'}`}/>

                <div className="qr-code__image--1"/>
                <div className="qr-code__image--2"/>
                <div className="qr-code__image--3"/>
                <div className="qr-code__image--4"/>

                {errorsHealthUserInfo.length > 0 && (
                  <div className="qr-code__image--5">
                    {errorsHealthUserInfo?.map((error: any) => {
                      return (
                        <p className="error-box__content">{error.message}</p>
                      );
                    })}
                  </div>
                )}

                {errorsHealthUserInfo.length < 1 && (
                  <>
                    <div ref={scanDiv} className="">
                      {" "}
                    </div>
                    {/* <img src={qrcode} alt=""/> */}
                    <QRCode
                      value={healthUserInfo.qrCode}
                      size={150}
                      renderAs="svg"
                      imageSettings={{
                        src: status[healthUserInfo.covidStatus]
                          ? status[healthUserInfo.covidStatus]
                            ? status[healthUserInfo.covidStatus].logo
                            : ""
                          : "",
                        width: 20,
                        height: 20,
                        excavate: true,
                      }}
                    />
                  </>
                )}
              </div>

              <div className="qr-code__id  u-margin-bottom-small-2">
                <span className="qr-code__id--title">شناسه کد:</span>
                <span className="qr-code__id--value">
                  {healthUserInfo.qrId}
                </span>
              </div>
            </div>
            {errorsHealthUserInfo.length < 1 && (
              <div className="qr-code__update">
                <span onClick={refreshQrCode}>
                  {/*<ConfirmLogoBlack/>*/}
                  <RefreshLogo2/>
                  <span>به روزرسانی QR کد</span>
                </span>
              </div>
            )}
          </div>
        )}

        <div className="u-margin-bottom-small-2 u-margin-top-small-3 u-width-100">
          <div className="profile-box">
            <div className="profile-box__table">
              {loading ? (
                <Skeleton count={2}/>
              ) : (
                <>
                  <div className="profile-box__table--row">
                    <label>کد ملی:</label>
                    <div className="input-eye-holder ">
                      {isHideNationalId ? (
                        <Eye
                          onHandleHide={setIsHideNationalId}
                          hide={isHideNationalId}
                        />
                      ) : (
                        <EyeClose
                          onHandleHide={setIsHideNationalId}
                          hide={isHideNationalId}
                        />
                      )}
                      <input
                        ref={nationalIdTag}
                        type={isHideNationalId ? "password" : "text"}
                        value={basicUserInfo.nationalId}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="profile-box__table--row">
                    <label>تاریخ تولد:</label>
                    <div className="input-eye-holder ">
                      {isHideBirthDate ? (
                        <Eye
                          onHandleHide={setIsHideBirthDate}
                          hide={isHideBirthDate}
                        />
                      ) : (
                        <EyeClose
                          onHandleHide={setIsHideBirthDate}
                          hide={isHideBirthDate}
                        />
                      )}

                      <input
                        ref={birthDateTag}
                        type={isHideBirthDate ? "password" : "text"}
                        value={basicUserInfo.birthDate}
                        readOnly
                      />
                    </div>
                  </div>
                </>
              )}
              {loading2 ? (
                <Skeleton count={3}/>
              ) : (
                <>
                  <div className="profile-box__table--row">
                    <label>وضعیت کوید:</label>
                    <span
                      className={
                        healthUserInfo.covidStatus === ""
                          ? ""
                          : status[healthUserInfo.covidStatus].class
                      }
                    >
                      {healthUserInfo.covidStatus === ""
                        ? "-"
                        : status[healthUserInfo.covidStatus].text}
                    </span>
                  </div>
                  <div className="profile-box__table--row">
                    <label>آخرین تاریخ آزمایش:</label>
                    <span
                      className={
                        healthUserInfo.covidStatus === "UNKNOWN" ||
                        healthUserInfo.covidStatus === null
                          ? "u-grey"
                          : ""
                      }
                    >
                      {healthUserInfo.covidStatus !== "UNKNOWN" &&
                      healthUserInfo.receiptDate !== "" &&
                      healthUserInfo.receiptDate !== null
                        ? moment(healthUserInfo.receiptDate, "YYYY/MM/DD")
                          .locale("fa")
                          .format("YYYY/MM/DD")
                        : "ثبت نشده"}
                    </span>
                  </div>
                </>
              )}

              {
                vaccinationLoading ? (
                  <Skeleton count={3}/>
                ) : (
                  <>
                    <div
                      className="profile-box__table--row"
                      style={{borderBottom: "none"}}
                    >
                      <label>وضعیت واکسیناسیون :</label>
                      {/* {healthUserInfo.numberOfDozes === "" ? (
                      ""
                    ) : healthUserInfo.numberOfDozes <= 1 ? (
                      <span>انجام نشده</span>
                    ) : (
                      <span>انجام شده</span>
                    )} */}
                      {/* {healthUserInfo.vaccineHistory.length === 0 ? (
                      ""
                    ) : healthUserInfo.vaccineHistory.length > 2 ? (
                      <span>انجام شده</span>
                    ) : (
                      <span>انجام نشده</span>
                    )} */}

                      {/*
                      {vaccinationCardInfo?.length === 0 ? (
                        <span>انجام نشده</span>
                      ) : (
                        ""
                      )}
                      */}
                    </div>
                    <div className="vaccine-status">
                      <div className="vaccine-status--row">
                      <span className="vaccine-status__icon">
                        <Vaccine width={20} height={20}/>
                      </span>
                        <span className="vaccine-status__line"> </span>
                        <span className="vaccine-status__time">
                        {vaccinationCardInfo?.length === 0 ? (
                          "-"
                        ) : vaccinationCardInfo?.some(
                          (item: any) => item.vaccineNumber === 1
                        ) ? (
                          <>
                            <i>
                              <ConfirmLogo width={12} height={12}/>
                            </i>
                            <b>نوبت اول</b>
                          </>
                        ) : (
                          <>
                            <i>
                              <CloseIconX2 width={10} height={10}/>
                            </i>
                            <b>نوبت اول</b>
                          </>
                        )}
                      </span>
                      </div>
                    </div>
                    <div className="vaccine-status">
                      <div className="vaccine-status--row">
                      <span className="vaccine-status__icon">
                        <Vaccine width={20} height={20}/>
                      </span>
                        <span className="vaccine-status__line"> </span>
                        <span className="vaccine-status__time">
                        {vaccinationCardInfo?.length === 0 ? (
                          "-"
                        ) : vaccinationCardInfo?.some(
                          (item: any) => item.vaccineNumber === 2
                        ) ? (
                          <>
                            <i>
                              <ConfirmLogo width={12} height={12}/>
                            </i>
                            <b>نوبت دوم</b>
                          </>
                        ) : (
                          <>
                            <i>
                              <CloseIconX2 width={10} height={10}/>
                            </i>
                            <b>نوبت دوم</b>
                          </>
                        )}
                      </span>
                      </div>
                    </div>

                    <div className="vaccine-status">
                      <div className="vaccine-status--row">
                      <span className="vaccine-status__icon">
                        <Vaccine width={20} height={20}/>
                      </span>
                        <span className="vaccine-status__line"> </span>
                        <span className="vaccine-status__time">
                        {vaccinationCardInfo?.length === 0 ? (
                          "-"
                        ) : vaccinationCardInfo?.some(
                          (item: any) => item.vaccineNumber === 3
                        ) ? (
                          <>
                            <i>
                              <ConfirmLogo width={12} height={12}/>
                            </i>
                            <b>نوبت سوم</b>
                          </>
                        ) : (
                          <>
                            <i>
                              <CloseIconX2 width={10} height={10}/>
                            </i>
                            <b>نوبت سوم</b>
                          </>
                        )}
                      </span>
                      </div>
                    </div>
                  </>
                )
              }


            </div>
            {healthUserInfo.covidStatus === "POSITIVE" && (
              <div className="profile-info u-margin-top-small-3">
                <div className="profile-info__title-1 u-margin-bottom-small-1">
                  <Danger/>
                  <p>لطفا دستورالعمل های قرنطینه را رعایت بفرمایید.</p>
                </div>
                <div className="profile-info__title-2">
                  <Info/>
                  <p
                    onClick={() => {
                      window.open(
                        "http://health.sbmu.ac.ir/index.jsp?pageid=63966&p=1",
                        "_blank"
                      );
                    }}
                  >
                    بخش آموزش های کوید را مطالعه بفرمایید.
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default Profile;
